"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePagination = void 0;
const react_1 = require("react");
const ItemList_1 = require("../../common/models/ItemList");
const usePagination = (initialPage, initialPageSize, fetchFunction, deduplicateBy, transformFunction, extractExtraData) => {
    const [data, setData] = (0, react_1.useState)({
        items: [],
        pagination: {
            totalItems: 0,
            totalPages: 0,
            pageSize: initialPageSize,
            currentPage: parseInt(localStorage.getItem('currentPage') || '') || initialPage,
            sort: [{ field: 'orderTime', direction: 'desc' }],
        },
    });
    const [extraData, setExtraData] = (0, react_1.useState)(undefined);
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [loadedPages, setLoadedPages] = (0, react_1.useState)(new Set());
    const fetchData = async (page, pageSize, append = false, debounceFilterValue, machineIds, clubIds, startDate, endDate, year, month, sort, isOnline) => {
        setLoading(true);
        try {
            const result = await fetchFunction(page, pageSize, debounceFilterValue, machineIds, clubIds, startDate, endDate, year, month, sort, isOnline);
            const itemList = transformFunction
                ? transformFunction(result)
                : result;
            const extra = extractExtraData ? extractExtraData(result) : undefined;
            if (itemList.items.length === 0) {
                setData((0, ItemList_1.emptyList)());
                setExtraData(undefined);
                return;
            }
            setData((prevData) => {
                const newItems = append
                    ? [...(prevData.items || []), ...(itemList.items || [])]
                    : itemList.items || [];
                const itemsMap = new Map();
                newItems.forEach((item) => {
                    const key = deduplicateBy(item);
                    itemsMap.set(key, item);
                });
                const uniqueItems = Array.from(itemsMap.values());
                return {
                    ...prevData,
                    items: uniqueItems,
                    pagination: {
                        ...itemList.pagination,
                        currentPage: page,
                        sort: sort?.length ? sort : [],
                    },
                };
            });
            setExtraData(extra);
            setLoadedPages((prevLoadedPages) => new Set(prevLoadedPages.add(page)));
        }
        catch (error) {
            console.error('Error fetching data:', error);
        }
        finally {
            setLoading(false);
        }
    };
    return { data, extraData, loading, fetchData, loadedPages };
};
exports.usePagination = usePagination;
